import { Autocomplete, Box, FormControl, Grid, IconButton, MenuItem, Paper, Select, Stack, TextField, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react'
import { useAuthContext } from 'src/auth/useAuthContext';
import CustomTable from 'src/components/CustomTable';
import Pagination from 'src/components/pagination';
import { VendorContext } from 'src/contexts/VendorContext';
import usePagination from 'src/hooks/usePagination';
import getAllVendorCampaign from 'src/services/campian/allVendorCampaign';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useNavigate } from 'react-router';
const getStatusDotStyle = {
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    display: "inline-block",
};

const getStatusTextWithColor = (status) => {
    let text = "";
    let color = "";

    switch (status) {
        case 0:
            text = "Pending";
            color = "#FF2626";
            break;
        case 1:
            text = "Ongoing";
            color = "#F38505";
            break;
        case 2:
            text = "Scheduled";
            color = "#F38505";
            break;
        case 3:
            text = "Completed";
            color = "#4CAF50";
            break;
        case 4:
            text = "Failed";
            color = "#FF2626";
            break;
        case "stopped":
            text = "Stopped";
            color = "#FF2626";
            break;
        case "paused":
            text = "Paused";
            color = "#FF2626";
            break;
        default:
            text = "Pending";
            color = "#FF2626";
            break;
    }

    return (
        <div>
            <span style={{ ...getStatusDotStyle, backgroundColor: color }}></span>
            <span style={{ marginLeft: "6px", color }}>{text}</span>
        </div>
    );
};
export default function AllCampaign() {
    const { user } = useAuthContext()
    const { vendors, getVendor } = useContext(VendorContext);
    const { page, setTotalPages, totalPages, setPage, page_size, setTotal_records, total_records, handlePageSize } = usePagination()
    const [vendorId, setVendorId] = useState({})
    const [date, setDate] = useState(dayjs())
    const navigate = useNavigate()

    useEffect(() => {
        const fetchVendor = async () => {
            try {
                await getVendor(0, true);
            } catch (error) {
                console.error(error);
            } finally {
            }
        };
        fetchVendor();
    }, [getVendor]);
    const [campaign_counts, setCampaign_counts] = useState({})
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        const fetchData = async () => {
            try {
                let from_date = dayjs(date).startOf("month").format()
                let till_date = dayjs(date).endOf("month").format()
                setLoading(true)
                const response = await getAllVendorCampaign(user, page, page_size, vendorId?._id, from_date, till_date)
                console.log(response, "response");
                if (response) {
                    setCampaign_counts(response?.campaign_counts)
                    setTotalPages(response?.totalPages);
                    setTotal_records(response?.total_records);
                    setRows(response?._payload || [])
                }
            } catch (er) {
                console.log(err);
            } finally {
                setLoading(false)
            }

        }
        fetchData()
    }, [page, page_size, vendorId?._id, date])

    const columns = [
        {
            id: "SI No",
            label: "SI No",
            renderCell: (_, index) => {
                return index + 1;
            },
        },
        {
            id: "vendor_name",
            label: "Partner Name",
            renderCell: (row, index) => {
                return row?.vendor_name
            },
        },
        {
            id: "Campaign Name",
            label: "Campaign Name",
            renderCell: (row, index) => {
                return row?.name
            },
        },
        {
            id: "credits_used",
            label: "Credits Used",
        },
        {
            id: "Status",
            label: "Status",
            renderCell: (row, index) => {
                return getStatusTextWithColor(
                    row.campaign_status === "completed"
                        ? 3
                        : row.campaign_status === "scheduled"
                            ? 2
                            : row.campaign_status === "ongoing"
                                ? 1
                                : row.campaign_status === "failed"
                                    ? 4
                                    : row.campaign_status
                )
            },
        },
        {
            id: "Template Name",
            label: "Template Name",
            renderCell: (row, index) => {
                return row?.template?.name
            },
        },
        {
            id: "created_by_user_name",
            label: "Create By",
        },
        {
            id: "created_by_user_role",
            label: "Role",
        },
        {
            id: "Schedule",
            label: "Schedule",
            renderCell: (row,) => {
                return dayjs(row?.schedule).format("DD/MM/YYYY hh:mm A")
            },
            width: 200
        },
        {
            id: "Start Campaign",
            label: "Start Campaign",
            renderCell: (row,) => {
                return dayjs(row?.started_at).format("DD/MM/YYYY hh:mm A")
            },
            width: 200
        },
        {
            id: "End Campaign",
            label: "End Campaign",
            renderCell: (row,) => {
                return dayjs(row?.started_at).format("DD/MM/YYYY hh:mm A")
            },
            width: 200
        },

        {
            id: "CreatedAt",
            label: "CreatedAt",
            renderCell: (row, index) => {
                return dayjs(row?.createdAt).format("DD/MM/YYYY hh:mm A")
            },
            width: 200
        },
        {
            id: "Action",
            label: "Action",
            renderCell: (row, index) => {
                return (
                    <Stack direction="row" gap="10px" justifyContent="center">

                        <IconButton onClick={() => handleCampaignDetails(row)}>
                            <RemoveRedEyeIcon />
                        </IconButton>
                    </Stack>
                )
            },
        },
    ]
    const handleCampaignDetails = (row) => {
        navigate(`view/${row?._id}`, {
            state: {
                data: row,
            },
        });
    };
    return (
        <div>
            <Stack direction="row" justifyContent="space-between" mb={2} flexWrap="wrap" gap={1}>
                <Typography variant='h5' >
                    All Campaigns
                </Typography>
                <Stack direction="row" gap={2} flexWrap="wrap">
                    <Stack >
                        <Autocomplete
                            id="checkboxes-tags-demo"
                            options={[...vendors]}
                            disableCloseOnSelect
                            limitTags={2}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            renderOption={(props, option,) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(_, val) => {
                                setVendorId(val);
                            }}

                            style={{ width: "250px" }}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Partners"
                                    placeholder="Select Partners" />
                            )}
                        />
                    </Stack>
                    <DatePicker
                        onChange={(date) => {
                            console.log(date);
                            setDate(date)
                        }}
                        views={["month", 'year',]}
                        value={date}
                    />
                </Stack>
            </Stack>
            <Grid container spacing={1}>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper sx={{ padding: "40px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", alignItems: "center", border: 1, borderColor: "divider" }}>
                        <Typography variant="h5" color="primary">
                            {campaign_counts?.completed || 0}
                        </Typography>
                        <Typography variant="body2">
                            Complete Campaign
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper sx={{ padding: "40px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", alignItems: "center", border: 1, borderColor: "divider" }}>
                        <Typography variant="h5" color="primary">
                            {campaign_counts?.scheduled || 0}
                        </Typography>
                        <Typography variant="body2">
                            Scheduled Campaign
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper sx={{ padding: "40px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", alignItems: "center", border: 1, borderColor: "divider" }}>
                        <Typography variant="h5" color="primary">
                            {campaign_counts?.pending || 0}
                        </Typography>
                        <Typography variant="body2">
                            Pending Campaign
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper sx={{ padding: "40px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", alignItems: "center", border: 1, borderColor: "divider" }}>
                        <Typography variant="h5" color="primary">
                            {campaign_counts?.failed || 0}
                        </Typography>
                        <Typography variant="body2">
                            Failed Campaign
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper sx={{ padding: "40px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", alignItems: "center", border: 1, borderColor: "divider" }}>
                        <Typography variant="h5" color="primary">
                            {campaign_counts?.paused || 0}
                        </Typography>
                        <Typography variant="body2">
                            Paused Campaign
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={3} lg={2}>
                    <Paper sx={{ padding: "40px 10px", display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", alignItems: "center", border: 1, borderColor: "divider" }}>
                        <Typography variant="h5" color="primary">
                            {campaign_counts?.stopped || 0}
                        </Typography>
                        <Typography variant="body2">
                            Stopped Campaign
                        </Typography>
                    </Paper>
                </Grid>
                {<Grid item xs={12} mt={2}>
                    {(loading || rows?.length > 0) && <CustomTable
                        rows={rows}
                        columns={columns}
                        loading={loading}
                    />}
                    {rows?.length > 0 && <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        justifyContent="space-between"
                        gap={1}
                        mt={2}
                    >
                        <Box
                            minWidth={220}
                            width={{ xs: "100%", sm: "max-content" }}
                            alignSelf={{ xs: "center", sm: "auto" }}
                        >
                            <Typography
                                sx={{ textAlign: { xs: "center", sm: "normal" } }}
                                color="primary"
                                variant="body1"
                            >{`Showing ${page !== 0 ? page * page_size : 1}  to ${(page + 1) * page_size > total_records
                                ? total_records
                                : (page + 1) * page_size
                                } of ${total_records} entries`}</Typography>
                        </Box>
                        <Box sx={{ order: { xs: 2, sm: 0 } }} flex={{ xs: 0, sm: 1 }}>
                            <FormControl
                                sx={{ maxWidth: "max-content", flexGrow: 1 }}
                                fullWidth
                            >
                                <Select
                                    className="custom-select"
                                    sx={{
                                        "&.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.custom-select":
                                        {
                                            height: "37px",
                                        },
                                    }}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={page_size}
                                    onChange={handlePageSize}
                                    color="primary"
                                    renderValue={() => `${page_size} per page`}
                                >
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={25}>25</MenuItem>
                                    <MenuItem value={50}>50</MenuItem>
                                    <MenuItem value={75}>75</MenuItem>
                                    <MenuItem value={100}>100</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Pagination
                            page={page}
                            setPage={setPage}
                            totalPages={totalPages}
                        />
                    </Stack>}
                </Grid>}
            </Grid>
        </div>
    )
}
